import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { RgActivityList } from '../../../../../../shared/interfaces/rg-activity-list.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivitiesTsService } from '../../../../../../services/dashboard/activities/activities.ts.service';
import { UserService } from '../../../../../../services/users/user.service';

@Component({
  selector: 'app-modal-activities-selection',
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-activities-selection.component.html',
  styleUrl: './modal-activities-selection.component.css',
})
export class ModalActivitiesSelectionComponent implements OnInit {
  @Output() openModalActivities: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() selected = new EventEmitter<RgActivityList[]>();

  @Input() title: string | undefined;

  @Input() rows: RgActivityList[] | undefined;

  public medicineId = 0;
  public countryId = 1;
  public companyId: any;

  selectedRowIndex: number = -1;

  selectedRows: RgActivityList[] = []; // Array per memorizzare le righe selezionate

  constructor(
    private dataService: DataService,
    private userPreferences: UserService,
    private activityService: ActivitiesTsService,
  ) {}

  ngOnInit(): void {
    this.medicineId = sessionStorage.getItem('medicineId')
      ? Number(sessionStorage.getItem('medicineId'))
      : 0;
    this.countryId = sessionStorage.getItem('countryId')
      ? Number(sessionStorage.getItem('countryId'))
      : 1;
    this.companyId = sessionStorage.getItem('companyId');
    const stored = sessionStorage.getItem('activities');
    const savedActivityNames: number[] = stored ? JSON.parse(stored) : [];

    if (this.companyId && this.medicineId) {
      this.dataService
        .getRegionalActivityListByMedicine(this.companyId, this.medicineId)
        .subscribe((data: RgActivityList[]) => {
          // Filter activities not present from sessionstorage
          this.rows = data.filter(
            (activity: RgActivityList) =>
              !savedActivityNames.includes(activity.activityId),
          );
        });
    }
  }

  oncloseModal() {
    this.openModalActivities.emit(false);
  }

  /*onSaveClick (): void {
    this.openModalActivities.emit(false);
    // this.selected.emit(this.selectedRows);
    console.log('selected row ', this.selectedRows);
    const activityIds = this.selectedRows.map(row => row.activityId);
    console.log('selected name ', activityIds);

    this.activityService.setSelectedRows(activityIds);
  }*/

  onSaveClick(): void {
    this.openModalActivities.emit(false);
    const username = sessionStorage.getItem('username') || '';
    const activityIds = this.selectedRows.map((row) => row.activityId);

    this.activityService.setSelectedRows(activityIds);

    const idsToSave = sessionStorage.getItem('activities')
      ? JSON.parse(sessionStorage.getItem('activities') || '[]')
      : [];
    this.userPreferences.getPreferencesByUsername(username).subscribe({
      next: (existingPreferences) => {
        const payload = {
          username,
          companyId: this.companyId,
          relevantActivities: idsToSave,
        };

        if (existingPreferences) {
  // update preferences
  this.userPreferences.updateUserPreferences(payload).subscribe({
    next: () => {},
    error: () => {},
  });
} else {
  // create preferences
  this.userPreferences.savePreferences(payload).subscribe({
    next: () => {},
    error: () => {},
  });
}
      },
      error: (err) => {
        // In case user has no preferences yet (or fetch failed), try to save new
        const payload = {
          username,
          companyId: this.companyId,
          relevantActivities: idsToSave,
        };

        this.userPreferences.savePreferences(payload).subscribe({
          next: () => console.log('Preferences saved successfully (fallback)'),
          error: (err2) => console.error('Fallback save failed', err2),
        });
      },
    });
  }

  selectRow(row: RgActivityList): void {
    if (this.selectedRows.includes(row)) {
      this.selectedRows = this.selectedRows.filter((r) => r !== row);
    } else {
      this.selectedRows.push(row);
    }
  }

  searchTerm: string = '';

  filteredRows(): RgActivityList[] {
    if (!this.searchTerm) {
      return this.rows!;
    }

    return (this.rows ?? []).filter((row) =>
      row.name.toLowerCase().includes(this.searchTerm.toLowerCase()),
    );
  }
}
